export const mensShirts = [
  {
    id: 1,
    name: 'Vape Cloud Chaser',
    price: 29.99,
    image: 'https://public.readdy.ai/ai/img_res/813adefe205c949146e8e785dd6c1067.jpg',
    category: 'Men\'s Shirts',
  },
  {
    id: 2,
    name: 'Neon Vapor Wave',
    price: 32.99,
    image: 'https://readdy.ai/api/search-image?query=Dark%20gray%20t-shirt%20featuring%20neon%20purple%20geometric%20vape%20mod%20illustration%20with%20glowing%20effects%2C%20cyberpunk%20aesthetic%2C%20product%20shot%20on%20clean%20white%20background%2C%20professional%20commercial%20photography&width=400&height=500&seq=ms2&orientation=portrait',
    category: 'Men\'s Shirts',
  },
  {
    id: 3,
    name: 'Smoke Master',
    price: 28.99,
    image: 'https://readdy.ai/api/search-image?query=Black%20cotton%20t-shirt%20with%20bold%20neon%20pink%20and%20purple%20smoke%20trail%20graphic%20design%2C%20edgy%20urban%20style%2C%20isolated%20on%20white%20background%2C%20studio%20product%20photography&width=400&height=500&seq=ms3&orientation=portrait',
    category: 'Men\'s Shirts',
  },
  {
    id: 4,
    name: 'Electric Clouds',
    price: 31.99,
    image: 'https://readdy.ai/api/search-image?query=Navy%20blue%20t-shirt%20with%20electric%20neon%20purple%20cloud%20formations%20and%20lightning%20effects%2C%20modern%20vape%20culture%20design%2C%20white%20background%20product%20photo%2C%20high%20resolution%20commercial%20image&width=400&height=500&seq=ms4&orientation=portrait',
    category: 'Men\'s Shirts',
  },
  {
    id: 5,
    name: 'Vape Life',
    price: 27.99,
    image: 'https://readdy.ai/api/search-image?query=Charcoal%20gray%20t-shirt%20featuring%20neon%20purple%20vape%20life%20typography%20with%20smoke%20effects%2C%20contemporary%20streetwear%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=ms5&orientation=portrait',
    category: 'Men\'s Shirts',
  },
  {
    id: 6,
    name: 'Purple Haze',
    price: 33.99,
    image: 'https://readdy.ai/api/search-image?query=Black%20premium%20t-shirt%20with%20abstract%20neon%20purple%20and%20pink%20haze%20pattern%2C%20artistic%20vape%20theme%20design%2C%20isolated%20white%20background%2C%20studio%20quality%20product%20shot&width=400&height=500&seq=ms6&orientation=portrait',
    category: 'Men\'s Shirts',
  },
];

export const womensShirts = [
  {
    id: 7,
    name: 'Vape Queen',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=Fitted%20black%20women%5Cs%20t-shirt%20with%20elegant%20neon%20purple%20crown%20and%20vape%20cloud%20design%2C%20feminine%20cut%2C%20white%20background%20product%20photography%2C%20high%20quality%20commercial%20image&width=400&height=500&seq=ws1&orientation=portrait',
    category: 'Women\'s Shirts',
  },
  {
    id: 8,
    name: 'Neon Dreams',
    price: 31.99,
    image: 'https://readdy.ai/api/search-image?query=Soft%20pink%20women%5Cs%20fitted%20tee%20featuring%20neon%20purple%20dreamy%20cloud%20graphics%2C%20stylish%20vape%20culture%20design%2C%20clean%20white%20background%2C%20professional%20product%20photo&width=400&height=500&seq=ws2&orientation=portrait',
    category: 'Women\'s Shirts',
  },
  {
    id: 9,
    name: 'Cloud Princess',
    price: 28.99,
    image: 'https://readdy.ai/api/search-image?query=White%20women%5Cs%20v-neck%20t-shirt%20with%20vibrant%20neon%20purple%20and%20pink%20cloud%20princess%20graphic%2C%20modern%20feminine%20style%2C%20isolated%20white%20background%2C%20studio%20product%20photography&width=400&height=500&seq=ws3&orientation=portrait',
    category: 'Women\'s Shirts',
  },
  {
    id: 10,
    name: 'Vapor Goddess',
    price: 32.99,
    image: 'https://readdy.ai/api/search-image?query=Black%20fitted%20women%5Cs%20tee%20with%20mystical%20neon%20purple%20goddess%20silhouette%20and%20vapor%20effects%2C%20elegant%20design%2C%20white%20background%20product%20shot%2C%20commercial%20quality%20photo&width=400&height=500&seq=ws4&orientation=portrait',
    category: 'Women\'s Shirts',
  },
  {
    id: 11,
    name: 'Electric Vibes',
    price: 30.99,
    image: 'https://readdy.ai/api/search-image?query=Gray%20women%5Cs%20fitted%20t-shirt%20featuring%20electric%20neon%20purple%20wave%20patterns%20and%20vibe%20typography%2C%20contemporary%20style%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=ws5&orientation=portrait',
    category: 'Women\'s Shirts',
  },
  {
    id: 12,
    name: 'Smoke & Shine',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=Navy%20blue%20women%5Cs%20fitted%20tee%20with%20sparkling%20neon%20purple%20smoke%20trail%20and%20shine%20effects%2C%20stylish%20vape%20design%2C%20white%20background%20studio%20photo%2C%20high%20resolution%20product%20image&width=400&height=500&seq=ws6&orientation=portrait',
    category: 'Women\'s Shirts',
  },
];

export const accessories = [
  {
    id: 13,
    name: 'Neon Vape Hat',
    price: 24.99,
    image: 'https://readdy.ai/api/search-image?query=Black%20snapback%20cap%20with%20embroidered%20neon%20purple%20vape%20logo%2C%20modern%20streetwear%20accessory%2C%20simple%20white%20background%2C%20professional%20product%20photography%2C%20centered%20composition&width=400&height=400&seq=acc1&orientation=squarish',
    category: 'Hats',
  },
  {
    id: 14,
    name: 'Cloud Chaser Cap',
    price: 22.99,
    image: 'https://readdy.ai/api/search-image?query=Purple%20trucker%20hat%20with%20neon%20pink%20cloud%20chaser%20text%20embroidery%2C%20mesh%20back%20design%2C%20clean%20white%20background%2C%20studio%20product%20shot%2C%20high%20quality%20commercial%20photo&width=400&height=400&seq=acc2&orientation=squarish',
    category: 'Hats',
  },
  {
    id: 15,
    name: 'Vape Case Pro',
    price: 19.99,
    image: 'https://readdy.ai/api/search-image?query=Sleek%20black%20vape%20carrying%20case%20with%20neon%20purple%20zipper%20and%20logo%2C%20protective%20hard%20shell%20design%2C%20isolated%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=acc3&orientation=squarish',
    category: 'Cases',
  },
  {
    id: 16,
    name: 'Premium Vape Pouch',
    price: 15.99,
    image: 'https://readdy.ai/api/search-image?query=Compact%20purple%20vape%20storage%20pouch%20with%20neon%20pink%20accents%2C%20soft%20material%20texture%2C%20simple%20white%20background%2C%20studio%20quality%20product%20image&width=400&height=400&seq=acc4&orientation=squarish',
    category: 'Cases',
  },
  {
    id: 17,
    name: 'Neon Skull Decal',
    price: 8.99,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20neon%20purple%20skull%20with%20vape%20smoke%20vinyl%20decal%20sticker%2C%20glowing%20effect%20design%2C%20white%20background%20product%20photo%2C%20high%20resolution%20commercial%20image&width=400&height=400&seq=acc5&orientation=squarish',
    category: 'Decals',
  },
  {
    id: 18,
    name: 'Cloud Logo Decal',
    price: 7.99,
    image: 'https://readdy.ai/api/search-image?query=Neon%20pink%20and%20purple%20cloud%20formation%20vinyl%20decal%20with%20glossy%20finish%2C%20modern%20vape%20culture%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=acc6&orientation=squarish',
    category: 'Decals',
  },
];
